import { cx } from '../utils/cx.js';

/** C-11 読込中: スケルトン（地は bg/sunken、動く帯は bg/card）。画面全体を覆わない */
export function Skeleton({ className, width, height = 16 }: { className?: string; width?: string | number; height?: string | number }) {
  return (
    <span
      aria-hidden="true"
      className={cx('block animate-pulse rounded-input bg-sunken', className)}
      style={{ width: width ?? '100%', height }}
    />
  );
}

export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={cx('flex flex-col gap-3', className)} aria-busy="true" aria-label="読み込み中">
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} width={i === lines - 1 ? '60%' : '100%'} />
      ))}
    </div>
  );
}

export function SkeletonList({ rows = 5, className }: { rows?: number; className?: string }) {
  return (
    <div className={cx('flex flex-col gap-3', className)} aria-busy="true" aria-label="読み込み中">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="rounded-card border border-[var(--card-border-color)] bg-card p-5 shadow-elev-1">
          <div className="flex items-center justify-between gap-4">
            <Skeleton width="45%" height={20} />
            <Skeleton width={72} height={24} className="rounded-pill" />
          </div>
          <Skeleton width="70%" className="mt-3" />
        </div>
      ))}
    </div>
  );
}

export function SkeletonForm({ fields = 4 }: { fields?: number }) {
  return (
    <div className="flex flex-col gap-5" aria-busy="true" aria-label="読み込み中">
      {Array.from({ length: fields }, (_, i) => (
        <div key={i} className="flex flex-col gap-2">
          <Skeleton width={120} height={16} />
          <Skeleton height={48} />
        </div>
      ))}
    </div>
  );
}
